"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClients = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var react_1 = require("react");
var invert_1 = (0, tslib_1.__importDefault)(require("lodash/fp/invert"));
var AuthContext_1 = require("../AuthContext");
var fetchClients_1 = require("./fetchClients");
var cache_1 = require("../../cache");
var regex = new RegExp('._PingIDP', 'g');
var useClients = function () {
    var authContext = (0, react_1.useContext)(AuthContext_1.AuthContext);
    var selectedClientInCache = cache_1.fosCache.getItem(cache_1.CLIENT_ID_CACHE_KEY);
    var selectedObfClientInCache = cache_1.fosCache.getItem(cache_1.OBF_CLIENT_ID_CACHE_KEY);
    var _a = (0, fetchClients_1.useFetchClients)(), _b = _a.data, clientData = _b === void 0 ? {} : _b, status = _a.status, error = _a.error;
    var loading = status === 'loading';
    if (error) {
        console.log('CLIENT ERROR:', error);
    }
    var clientsList = Object.values(clientData);
    var obfuscatedClientIds = (0, invert_1.default)(clientData);
    var clients = (0, react_1.useMemo)(function () {
        return clientsList ? clientsList.filter(function (group) { return !group.match(regex); }) : null;
    }, [clientsList]);
    var selectedClient = (function () {
        if (selectedClientInCache && selectedObfClientInCache) {
            return selectedClientInCache;
        }
        var selectedClientByDefault = clients && clients.length === 1 ? clients[0] : null;
        cache_1.fosCache.setItem(cache_1.OBF_CLIENT_ID_CACHE_KEY, obfuscatedClientIds[selectedClientByDefault] || null, { priority: 1 });
        cache_1.fosCache.setItem(cache_1.CLIENT_ID_CACHE_KEY, selectedClientByDefault, {
            priority: 1,
        });
        return selectedClientByDefault;
    })();
    if (authContext === undefined) {
        throw new Error('`useAuth` hook must be used within a `AuthProvider` component');
    }
    var selectClient = function (newClient) {
        cache_1.fosCache.clear();
        cache_1.fosCache.setItem(cache_1.OBF_CLIENT_ID_CACHE_KEY, obfuscatedClientIds[newClient] || null, { priority: 1 });
        cache_1.fosCache.setItem(cache_1.CLIENT_ID_CACHE_KEY, newClient, { priority: 1 });
        window.location.reload();
    };
    return {
        clients: clients,
        selectedClient: selectedClient,
        selectClient: selectClient,
        loading: loading,
    };
};
exports.useClients = useClients;
